import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

export default function PaginationPage({ page, setPage, limit }){
    return (
        <div className="divGroupPagination" style={{marginTop: "1rem"}}>
            <button data-tip="Primeira página" onClick={() => setPage(1)} type="button" className="buttonFirstPage"><FaArrowLeft color="#001675" size={17} /><FaArrowLeft color="#001675" size={17} /></button>
            <button data-tip="Página anterior" onClick={() => setPage(page > 1 ? page - 1 : 1)} type="button" className="buttonPreviewPage"><FaArrowLeft color="#001675" size={17} /></button>
            <div className="divLabelPagination">
            <center><label className="labelPage">Exibindo página {page} de {limit}</label></center>
            </div>
            <button data-tip="Próxima página" onClick={() => setPage((page + 1) < limit ? page + 1 : limit)} type="button" className="buttonNextPage"><FaArrowRight color="#001675" size={17} /></button>
            <button data-tip="Última página" onClick={() => setPage(limit)} type="button" className="buttonLastPage"><FaArrowRight color="#001675" size={17} /><FaArrowRight color="#001675" size={17} /></button>
        </div>
    );
}